import ActionTypes from '../constants/ActionTypes';
import { State } from '../reducers';

export function isSiteAbnLoaded(state: State, key) {
  return !!(
    state.sitesAbn.status[key] &&
    state.sitesAbn.status[key] === ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS
  );
}

export function getSiteAbnByKey(state: State, key) {
  return state.sitesAbn.list[key];
}

export function getSiteAbnStatusByKey(state: State, key) {
  return state.sitesAbn.status[key];
}
